import {
  FETCH_BATCH_PROVISIONS_CONNECTIONS_SUCCESS,
  FETCH_BATCH_PROVISIONS_CONNECTIONS_FAILURE,
  SELECT_CONNECTION_FOR_BATCH_PROVISIONS,
  FETCH_BATCH_PROVISIONS_SUCCESS,
  FETCH_BATCH_PROVISIONS_FAILURE,
  FETCH_BATCH_PROVISIONS,
  SET_PROCESSED_SUCCESSFULLY_FILTER,
  UNSET_PROCESSED_SUCCESSFULLY_FILTER,
  SET_TRIAL_BALANCES_NOT_RECEIVED_FILTER,
  UNSET_TRIAL_BALANCES_NOT_RECEIVED_FILTER,
  SET_TRIAL_BALANCES_WITH_ERRORS_FILTER,
  UNSET_TRIAL_BALANCES_WITH_ERRORS_FILTER,
  SET_CALCULATION_ERRORS_FILTER,
  UNSET_CALCULATION_ERRORS_FILTER,
  SET_JOURNALS_FILTER,
  UNSET_JOURNALS_FILTER,
  SET_LOCAL_JOURNALS_FILTER,
  UNSET_LOCAL_JOURNALS_FILTER,
  INITIATE_CALC,
  INITIATE_CALC_FAILURE,
  INITIATE_CALC_SUCCESS,
  UPDATE_CONNECTION_STATUS,
  FETCH_COMPANY_CODES_FOR_CONNECTION_BATCH_PROVISION,
} from './types';
import initialSate from './initialState';
import { fetchReducerFactory } from '../../../shared/store/fetchFactory';

const fetchReducer = fetchReducerFactory({
  [FETCH_COMPANY_CODES_FOR_CONNECTION_BATCH_PROVISION]: 'CompanyCodesForConnection',
}, initialSate);

function batchProvisionsReducer(state = initialSate, action) {
  switch (action.type) {
    case FETCH_BATCH_PROVISIONS_CONNECTIONS_SUCCESS:
      return {
        ...state,
        connections: action.connections,
        isFetching: false,
      };
    case FETCH_BATCH_PROVISIONS_CONNECTIONS_FAILURE:
      return {
        ...state,
        isFetching: false,
      };
    case SELECT_CONNECTION_FOR_BATCH_PROVISIONS:
      return {
        ...state,
        connection: action.connection,
      };
    case FETCH_BATCH_PROVISIONS_SUCCESS:
      return {
        ...state,
        batchProvisionsWithStatus: action.batchProvisions,
        isFetching: false,
      };
    case INITIATE_CALC:
      return {
        ...state,
        isStartingCalc: true,
      };
    case FETCH_BATCH_PROVISIONS_FAILURE:
      return {
        ...state,
        isFetching: false,
      };
    case FETCH_BATCH_PROVISIONS:
      return {
        ...state,
        isFetching: true,
      };
    case SET_PROCESSED_SUCCESSFULLY_FILTER:
      return {
        ...state,
        processedSuccessfullyFilter: action.filter,
      };
    case UNSET_PROCESSED_SUCCESSFULLY_FILTER:
      return {
        ...state,
        processedSuccessfullyFilter: '',
      };
    case SET_TRIAL_BALANCES_NOT_RECEIVED_FILTER:
      return {
        ...state,
        trialBalancesNotReceivedFilter: action.filter,
      };
    case UNSET_TRIAL_BALANCES_NOT_RECEIVED_FILTER:
      return {
        ...state,
        trialBalancesNotReceivedFilter: '',
      };
    case SET_TRIAL_BALANCES_WITH_ERRORS_FILTER:
      return {
        ...state,
        trialBalancesWithErrorsFilter: action.filter,
      };
    case UNSET_TRIAL_BALANCES_WITH_ERRORS_FILTER:
      return {
        ...state,
        trialBalancesWithErrorsFilter: '',
      };
    case SET_CALCULATION_ERRORS_FILTER:
      return {
        ...state,
        calculationErrorsFilter: action.filter,
      };
    case UNSET_CALCULATION_ERRORS_FILTER:
      return {
        ...state,
        calculationErrorsFilter: '',
      };
    case SET_JOURNALS_FILTER:
      return {
        ...state,
        journalsFilter: action.filter,
      };
    case UNSET_JOURNALS_FILTER:
      return {
        ...state,
        journalsFilter: '',
      };
    case SET_LOCAL_JOURNALS_FILTER:
      return {
        ...state,
        localJournalsFilter: action.filter,
      };
    case UNSET_LOCAL_JOURNALS_FILTER:
      return {
        ...state,
        localJournalsFilter: '',
      };
    case INITIATE_CALC_SUCCESS:
    case INITIATE_CALC_FAILURE:
      return {
        ...state,
        isStartingCalc: false,
      };
    case UPDATE_CONNECTION_STATUS:
      return {
        ...state,
        batchProvisionsWithStatus: {
          ...state.batchProvisionsWithStatus,
          status: {
            ...state.batchProvisionsWithStatus.status,
            connStatus: action.connStatus,
            connStatusName: action.connStatusName,
          },
        },
      };
    default:
      return fetchReducer(state, action);
  }
}

export default batchProvisionsReducer;
